import { useCallback, useContext, useState } from 'react'
import { AppointmentsTableContext } from '../context'
import { useSelection } from '@shared/modules/next-table/hooks/use-selection'
import { AppointmentsService } from '../services'
import { message, Modal } from 'antd'
import { useBackgroundNavigate } from '@shared/hooks'

export const useAppointmentsTableActions = () => {
  const navigate = useBackgroundNavigate()

  const { state, handleFetch, handleReset, handleSelectAll, handleResetSelection } = useContext(AppointmentsTableContext)
  const selection = useSelection(state.selectedRowIds)
  const [filtersIsVisible, setFiltersIsVisible] = useState<boolean>(false)

  const openFilters = useCallback(() => {
    setFiltersIsVisible(true)
  }, [])

  const closeFilters = useCallback(() => {
    setFiltersIsVisible(false)
  }, [])

  const handleAction = useCallback(
    async (actionType) => {
      const handler = async () => {
        message.loading({ key: 'message', content: 'Əməliyyat aparılır.' })
        const result = await AppointmentsService.actionByIds(selection, actionType)

        if (result.status === 200) {
          message.success({ key: 'message', content: 'Əməliyyat müvəffəqiyyətlə başa çatdı' })
          await handleFetch()
        } else {
          message.error({ key: 'message', content: result.data as string })
        }
      }

      Modal.confirm({
        title: 'Əməliyyatı etməyinizə əminsinizmi?',
        content: 'Əməliyyatı etdikdən sonra məlumatların geri qaytarılması mümkün olmayacaq.',
        onOk: handler,
      })
    },
    [handleFetch, selection],
  )

  const goToCreate = useCallback(() => {
    navigate('/appointments/create', { withBackground: false })
  }, [navigate])

  return {
    selection,
    handleFetch,
    handleResetSelection,
    handleSelectAll,
    handleReset,
    handleAction,
    openFilters,
    closeFilters,
    filtersIsVisible,
    goToCreate,
  }
}
